import styled, { css } from "styled-components";
import { colors } from "healthex-common/colors";
import { fontWeights } from "healthex-common/weights";
import { fontSizes } from "healthex-common/sizes";
import { FlexRowDiv, FlexColumnDiv, InlineFlexRow } from "./common.styles";
import Badge from "@mui/material/Badge";
export const HXPageTitleText = styled.div `
    font-weight: ${fontWeights.SEMI_BOLD};
    font-size: ${fontSizes.TITLE};
    line-height: 40px;
`;
export const Subtitle = styled.div `
    color: ${colors.black_main};
    font-size: ${(props) => (props.fontSize ? props.fontSize : fontSizes.LARGE)};
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: normal;

    ${(props) => props.disabled &&
    css `
            color: ${colors.black_30};
        `}
`;
export const BoldSubtitle = styled(Subtitle) `
    font-weight: ${fontWeights.BOLD};
`;
export const LightSubtitle = styled(Subtitle) `
    color: ${colors.black_light};
`;
export const BaseText = css `
    color: ${colors.black_main};
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    letter-spacing: 0.15px;
`;
export const Text = styled.div `
    ${BaseText}
    color: ${(props) => (props.disabled ? colors.black_30 : props.color ? props.color : colors.black_main)};

    ${(props) => props.textAlign &&
    css `
            text-align: ${props.textAlign};
        `}

    ${(props) => props.error &&
    css `
            color: ${colors.tulip_main};
        `}
`;
export const InlineText = styled(Text) `
    display: inline;
`;
export const BoldText = styled(Text) `
    font-weight: ${fontWeights.BOLD};
`;
export const SemiBoldText = styled(Text) `
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const LightSemiBoldText = styled(SemiBoldText) `
    color: ${colors.black_light};
`;
export const LighterSemiBoldText = styled(SemiBoldText) `
    color: ${colors.black_lighter};
`;
export const InlineSemiBoldText = styled(SemiBoldText) `
    display: inline;
`;
export const LightText = styled(Text) `
    color: ${(props) => (props.disabled ? colors.black_30 : props.color ? props.color : colors.black_light)};
`;
export const BoldLightText = styled(LightText) `
    font-weight: ${fontWeights.BOLD};
`;
export const LighterText = styled(Text) `
    color: ${(props) => (props.disabled ? colors.black_30 : props.color ? props.color : colors.black_lighter)};
`;
export const PreWrapLighterText = styled(LighterText) `
    white-space: pre-wrap;
`;
export const BoldLighterText = styled(LighterText) `
    font-weight: ${fontWeights.BOLD};
`;
export const SmallText = styled(Text) `
    font-size: ${fontSizes.SMALL};
    letter-spacing: 0.17px;
`;
export const LightSmallText = styled(SmallText) `
    color: ${colors.black_light};
`;
export const LighterSmallText = styled(SmallText) `
    color: ${colors.black_lighter};
`;
export const SemiBoldSmallText = styled(SmallText) `
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const TinyText = styled(LightText) `
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.NORMAL};
    letter-spacing: 0.4px;
`;
export const LighterTinyText = styled(TinyText) `
    color: ${colors.black_lighter};
`;
export const ErrorMessageText = styled(Text) `
    color: ${(props) => (props.disabled ? colors.black_30 : props.color ? props.color : colors.tulip_main)};
`;
export const ErrorText = styled(TinyText) `
    color: ${colors.tulip_main};
    margin: 4px 14px 0 14px;
`;
export const ErrorTextInline = styled.span `
    color: ${(props) => (props.disabled ? colors.black_30 : colors.tulip_main)};
`;
export const HXSectionTitle = styled.div `
    color: ${colors.black_main};
    font-size: ${fontSizes.SUPER};
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: normal;
`;
export const HXSubsectionTitle = styled.div `
    color: ${colors.black_main};
    font-size: ${fontSizes.MEDIUM};
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: normal;
`;
export const HXSectionTitleText = styled(LightText) ``;
export const HXSectionTextContainer = styled(FlexRowDiv) `
    gap: 4px;
    align-items: center;
`;
export const HXSectionTitleWithRightElementContainer = styled(FlexRowDiv) `
    align-self: stretch;
    gap: 4px;
    justify-content: space-between;
    align-items: center;
`;
export const HXSectionTitleContainer = styled(FlexColumnDiv) `
    align-items: flex-start;
    gap: 4px;
`;
export const HXSectionTitleLabelContainer = styled(FlexColumnDiv) `
    align-items: flex-end;
    gap: 4px;
`;
const HXSectionBaseTitleAndTimestampText = styled.div `
    font-size: ${fontSizes.STANDARD};
    text-align: left;
    line-height: normal;
    letter-spacing: 0.15px;
`;
export const HXSectionSubtitleLabel = styled(HXSectionBaseTitleAndTimestampText) `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${(props) => (props.hasError ? colors.tulip_main : colors.black_light)};
`;
export const HXSectionTimestampLabel = styled(HXSectionBaseTitleAndTimestampText) `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
`;
export const HXSectionTimestamp = styled(HXSectionBaseTitleAndTimestampText) `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_lighter};
    &:first-letter {
        text-transform: capitalize;
    }
`;
export const HXSectionCard = styled(FlexColumnDiv) `
    border-radius: 4px;
    background: ${(props) => (props.isSunsetColor ? colors.sunset_8 : colors.white_main)};
    border: 1px solid ${(props) => (props.isSunsetColor ? colors.sunset_main : colors.black_12)};
    align-items: flex-start;
    align-self: stretch;
`;
export const PermissionError = styled(FlexRowDiv) `
    color: red;
    justify-content: center;
    margin: 80px 0;
`;
export const HXTabBadge = styled(Badge) `
    position: absolute;
    right: 0px;
    top: 5px;
    width: 8px;
    height: 8px;
    background-color: ${colors.accents_sunset};
    border-radius: 100px;
`;
const BaseUnderlinedText = css `
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-decoration: underline;
`;
export const TextUnderlined = styled(Text) `
    ${BaseUnderlinedText}
    &:hover {
        cursor: pointer;
    }
`;
export const TextLink = styled(TextUnderlined) `
    word-wrap: break-word;
    align-self: stretch;
`;
export const UnderlinedInline = styled.span `
    ${BaseUnderlinedText}
    &:hover {
        cursor: pointer;
    }
`;
export const InlineButtonContainer = styled(InlineFlexRow) `
    gap: 4px;
    align-items: flex-end;
    &:hover {
        cursor: pointer;
    }
`;
